import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793fc00c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back-button-wrapper" }
const _hoisted_2 = { class: "title max-width" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "actions-wrapper" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Platform:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Type:", -1))
const _hoisted_10 = { class: "price-wrapper" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_back = _resolveComponent("common-back")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_common_section = _resolveComponent("common-section")!
  const _component_layout_footer = _resolveComponent("layout-footer")!

  return (_ctx.shopItem != undefined)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "shop-item-container",
        style: _normalizeStyle(_ctx.cssProps)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_common_back, {
            location: { name: 'Shop' },
            text: _ctx.t('shop.back-to-shop'),
            class: "back-button max-width"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.shopItem.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.shopItem.image
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, _toDisplayString(_ctx.shopItem.tags.includes("xbox")
                    ? "XBOX"
                    : _ctx.shopItem.tags.includes("playstation")
                    ? "Playstation"
                    : _ctx.t("shop.pc")), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(_ctx.shopItem.tags.includes("gift")
                    ? _ctx.t("shop.giftcard")
                    : _ctx.t("shop.key")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.shopItem.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1),
                _hoisted_12
              ]),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addToCart()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fa', 'cart-plus'],
                  size: "lg",
                  class: "icon"
                })
              ])
            ])
          ])
        ]),
        _createVNode(_component_common_section, {
          class: "c-section",
          colorLeft: _ctx.mainColor,
          colorRight: _ctx.secondaryColor,
          text: _ctx.t('shop.product-description')
        }, null, 8, ["colorLeft", "colorRight", "text"]),
        _createElementVNode("div", {
          class: "description max-width",
          innerHTML: _ctx.shopItem.description
        }, null, 8, _hoisted_13),
        (_ctx.pageReady)
          ? (_openBlock(), _createBlock(_component_layout_footer, {
              key: 0,
              spot: _ctx.adSpotFooter
            }, null, 8, ["spot"]))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}